<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">
        Statistic
      </strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4>Statistics</h4>
            <a-table
              :columns="columns"
              :rowKey="record => record.index"
              :dataSource="data.statistic"
              :loading="loading"
            >
              <template slot="index" slot-scope="index">
                {{ index + 1 }}
              </template>
              <template slot="time" slot-scope="time">
                {{ time }}
              </template>
              <template slot="users" slot-scope="users">
                {{ users? users.length : 0 }}
              </template>
              <template slot="matched" slot-scope="matched">
                {{  matched ? matched : 0 }}
              </template>
              <template slot="success" slot-scope="success">
                {{ success? success : 0 }}
              </template>
            </a-table>
            <!-- Log -->
              <h4>Users Log</h4>
            <a-table
              :columns="columns2"
              :rowKey="record => record.index"
              :dataSource="data.user_log"
              :loading="loading"
            >
              <template slot="index" slot-scope="index">
                {{ index + 1 }}
              </template>
              <template slot="uid" slot-scope="uid">
                {{ uid }}
              </template>
              <template slot="fullname" slot-scope="fullname">
                {{fullname? fullname : "" }}
              </template>
              <template slot="time" slot-scope="time">
                {{time? formatDate(time*1000) : 0 }}
              </template>
              <template slot="action" slot-scope="action">
                {{action? action : "" }}
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    const columns = [
      {
        title: "#",
        width: "50px",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
      },
      {
        title: "Time",
        dataIndex: "time",
        width: "30%",
        scopedSlots: {
          customRender: "time"
        }
      },
      {
        title: "Users ",
        dataIndex: "users",
        width: "20%",
        scopedSlots: { customRender: "users" }
      },

      {
        title: "Matched",
        dataIndex: "matched",
        width: "20%",
        scopedSlots: { customRender: "matched" }
      },
      {
        title: "Success",
        dataIndex: "success",
        width: "20%",
        scopedSlots: { customRender: "success" }
      }
    ];
    const columns2 = [
      {
        title: "#",
        width: "50px",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
      },
      {
        title: "UID",
        dataIndex: "uid",
        width: "30%",
        scopedSlots: {
          customRender: "uid"
        }
      },
      {
        title: "Name ",
        dataIndex: "fullname",
        width: "20%",
        scopedSlots: { customRender: "fullname" }
      },

      {
        title: "Time LastSign",
        dataIndex: "time",
        width: "20%",
        scopedSlots: { customRender: "time" }
      },
      {
        title: "Action",
        dataIndex: "action",
        width: "20%",
        scopedSlots: { customRender: "action" }
      }
    ];
    return {
      columns,
      columns2,
      data: [],
      loading: false
    };
  },
  methods: {
    // sortTime(a){
    //       this.data = a.sort(function(a, b) {
    //         return (
    //           new Date(b.created_at).getTime() -
    //           new Date(a.created_at).getTime()
    //         );
    //       });
    // },
    formatDate(e) {
      let dd = new Date(e).getDate();
      let mm = new Date(e).getMonth() + 1; //January is 0!
      let yyyy = new Date(e).getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      return dd + "/" + mm + "/" + yyyy;
    },
    async loadData() {
      this.loading = true;
      console.log(this.$route.params.id);
      await this.api(
        "admin/statistic?action=detail&id=" + this.$route.params.id
      )
        .then(async res => {
          res.statistic = res.statistic.map((a, index) => {
            a.index = index;
            return a;
          });
          res.user_log = res.user_log.map((a, index) => {
            a.index = index;
            return a;
          });
          this.data = res;
          this.loading = false;
          this.data.statistic = this.data.statistic.sort(function(a, b) {
            return (
              new Date(b.time).getTime() -
              new Date(a.time).getTime()
            );
          });
          console.log("Du lieu statistic", this.data);
        })
        .finally(e => {});
    }
  },
  mounted() {
    this.loadData();
  },
  mixins: [api, helper]
};
</script>
<style scoped>
a {
  color: #ff5254;
}
a:hover {
  color: #08f;
}
</style>
